import React from 'react';

export default function Instructions(props) {
  return (
    <div className="instructions-text" id="instructions-text">
      {props.textToDisplay}
    </div>
  );
}
